// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#stawag-comparison-staging-gjuce #gc-comparison-step{position:relative}#stawag-comparison-staging-gjuce #gc-comparison-step .row:nth-child(n+2){border-bottom-width:1px}#stawag-comparison-staging-gjuce #gc-comparison-step .v-list-item{border-bottom:1px solid #ddd}#stawag-comparison-staging-gjuce #gc-comparison-step .v-list-item__title{overflow:initial;text-overflow:clip;white-space:normal}", ""]);
// Exports
module.exports = exports;
